const messages = {
  availPoints: "Elérhető pontok",
  awaitingPoints: "Függő pontok",
  board: {
    title: "Irányítópult",
    title2: "Kampányteljesítmény {year}",
    headline1: "Promóciói és pontjai egy helyen",
    headline2: "Szerezzen pontokat gumiabroncs-vásárlásai után.",
    pointsBalanceToDate: "PONTEGYENLEG AKTUÁLISAN",
    availPoints: "Elérhető pontok",
    awaitingPoints: "Függő pontok",
    yourRealisation: "AZ ÖN EREDMÉNYEI",
    yourEngagement: "Éves célja: <b>{tyres} gumiabroncs</b>",
    yourPoints: "AZ ÖN PONTJAI",
    yourRetailPurchase: "VÁSÁRLÁSAI RÉSZLETESEN",
    yourRetailPurchaseCCS: "ELADÁSAI RÉSZLETESEN",
    pointsByPurchase: "vásárlásokból szerzett pontok",
    pointsByBoosters: "boosterekből szerzett pontok",
    pointsByBSPurchase: "Bridgestone-vásárlásokból szerzett pontok",
    pointsByBSPurchaseCCS: "Bridgestone gumiabroncsok eladásából szerzett pontok",
    remaining: "Hátralévő gumiabroncsok",
    yourGoal: "Cél felé haladás",
    unit: "gumiabroncs",
    buttons: {
      learnMore: "Tudjon meg többet a pontjairól",
      learnMoreAboutMechanism: "Tudjon meg többet a mechanizmusról",
    },
    charts: {
      byBrand: "Márka szerint",
      bySize: "Felniátmérő<br/>szerint",
    },
    exploreResults: "Fedezze fel eredményeit",
    tyreLimitInfo:
      "Minden Booster kampányidőszakra legalább 50 Bridgestone és/vagy Firestone gumiabroncs sell-out mennyiség szükséges.",
  },
  charts: {
    byBrand: "Márka szerint",
    bySize: "felniátmérő szerint",
  },

  dashboard: {
    dashboardTitle: "Az Ön előnyei",
    dashboardBox: {
      title: "Pontegyenleg",
      description: "Marketingpontjainak aktuális száma",
      availPoints: "Elérhető pontok",
      awaitingPoints: "Függő pontok",
      lastUpdate: "Utolsó frissítés",
      button: "További információ",
      points: "pont",
    },
  },
  soldTyres: "ELADOTT GUMIABRONCSOK",
  receivedPoints: "SZERZETT PONTOK",
  boosterCCS: {
    personalInfo: "Személyes adatok",
    csNumberTitle: "Kérjük, adja meg a részt vevő fiók(ok) számát",
    tyresTitle: "Kérjük, adja meg az eladott gumiabroncsok számát",
    minTyresInfo:
      "Minimum {tyres} Bridgestone/Firestone gumiabroncs szükséges. A jutalmazás csak a Bridgestone gumiabroncsokra vonatkozik.",
    tyresAmount: "Gumiabroncsok száma",
    filesTitle: "Kérjük, töltse fel az értékesítési igazolásokat",
    filesDescription:
      "Megjegyzés: csak azok az eladások kerülnek figyelembevételre, amelyek tartalmazzák a gumiabroncs felniátmérőjét.",
    addAnotherFile: "Dokumentum hozzáadása",
    file: "Dokumentum feltöltése",
    formatInfo:
      "Támogatott fájlformátumok: xlsx, jpeg és pdf. Maximális fájlméret: 8 MB",
    confrimationMessage:
      "<b>Köszönjük a részvételt!</b> <br/>Kérelmét megkaptuk, és továbbítottuk a Bridgestone csapatának ellenőrzésre.<br/>A Booster CCS kampányban való részvételének eredményéről e-mailben értesítjük.<br/>Hamarosan találkozunk a Bridgestone Plus felületén!",
  },
  sharePointModal: {
    header: "Pontok megosztása",
    forShare: "Megosztandó pontok",
    title: "Cím",
  },
  notFoundFile: "Nincs fájl kiválasztva",
  chooseFile: "Fájl kiválasztása",
};

export default {
  messages,
};
